import {
  SUB_STAGE_SELECT,
  NUMBER_INPUT,
  TEXT_INPUT,
  SINGLE_OPTION_SELECT,
  OPTIONS_FROM_SERVER,
  MULTIPLE_OPTION_SELECT,
  MONTH_PICKER,
} from 'modules/questionnaire/questionTypes';
import { ensureArray } from 'functions/ensureArray';

const stringifyOptionValues = (options) => ensureArray(options || [])
  .map(({ value: optionValue }) => optionValue).sort().join(',');

const stringifyMonthPickerValue = (value) => {
  const { year = [], month = [] } = value || {};
  const [yearValue = null] = year;
  const [monthValue = null] = month;
  return `${yearValue}_${monthValue}`;
};

// TODO implement for the rest question types
export const checkQuestionAnswerChanged = (question, {
  form, preservedForm,
}) => {
  const { id: questionId } = question;
  const { [questionId]: questionValue } = form;
  const { [questionId]: preservedQuestionValue } = preservedForm;

  switch (question.type) {
    case SUB_STAGE_SELECT:
    case SINGLE_OPTION_SELECT: {
      return (questionValue?.value ?? null) !== (preservedQuestionValue?.value ?? null);
    }
    case NUMBER_INPUT:
      return String(questionValue) !== String(preservedQuestionValue);
    case TEXT_INPUT:
      return questionValue !== preservedQuestionValue;
    case MULTIPLE_OPTION_SELECT:
    case OPTIONS_FROM_SERVER:
      return stringifyOptionValues(questionValue) !== stringifyOptionValues(preservedQuestionValue);
    case MONTH_PICKER:
      return stringifyMonthPickerValue(questionValue) !== stringifyMonthPickerValue(preservedQuestionValue);
    default:
      return true;
  }
};
